export const DETAIL_TAB_PARAM_KEY = "horizontalSign-details"